
import React, { useEffect, useState } from "react";
import Button from "../../common/Button/Button";
import api from "../../../services/api";
const AddAccessTypes = ({ typeId, onSubmitted, onCancel }) => {
    const id = typeId;
    const [formData, setFormData] = useState({
        access_types: "",
        rights_type: ""
    });

    useEffect(() => {
        if (id) {
            api.get(`/access-types/${id}`)
                .then((res) => {

                    const role = res.data;
                    if (role) {
                        setFormData({
                            access_types: role.access_types || "",
                            rights_type: role.rights_type || ""
                        });
                    }
                })
                .catch((err) => console.error("Error loading access type:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            access_types: formData.access_types,
            rights_type: formData.rights_type
        }

        const apiCall = id
            ? api.put(`/access-types/${id}`, payload)  
            : api.post(`/access-types`, payload);     

        apiCall
            .then(() => { if (onSubmitted) onSubmitted(); })
            .catch((error) => console.error("Error:", error));
    };

    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">


                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Access Type</label>
                            <input
                                type="text"
                                name="access_types"
                                value={formData.access_types}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="formGroup">
                            <label>Rights</label>
                            <input
                                type="text"
                                name="rights_type"
                                value={formData.rights_type}
                                onChange={handleChange}
                                required
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddAccessTypes;